var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showConfirmEmail)?_c('li',[_vm._v("\n    "+_vm._s(_vm.$t('coupon.confirmEmail'))+" "+_vm._s(_vm.appointment.clientData.email)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }